import { getAnnouncementDetail, getAnnouncementList, updateAnnouncementList } from 'containers/OutBidding/api';
import { getListPathMenuKey } from 'containers/OutBidding/utils';
import React, { useEffect } from 'react'
import { useOpenBiddingModal } from '@mpc/common/src/features/BiddingModal/index';
import isBlank from 'utils/object';
import { refreshList } from 'modules/actions/smProjectMove';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import {Spin} from "@bedrock/components";

const NewAnnouncementModal = (props: any) => {
    const refresh = () => {
        // 如果已在列表弹框, 则刷新
        if (['toDoProcess'].includes(getListPathMenuKey())) {
            refreshList(getListPathMenuKey());
        }
    };

    const { id } = props;

    const getList = async () => {
        const res = await getAnnouncementList({});
        const { data } = res;
        if (data?.length) {
            openBiddingModal(data)
        }
    };

    const { openBiddingModal, destroy } = useOpenBiddingModal({
        updateAnnouncementList,
        refresh,
        isList: true,
        id,
        getList,
    })
    useEffect(() => {
        getList();
    }, []);
    return (
        <></>
    );
}


export function mapDispatchToProps(dispatch: Dispatch<any>, ownProps: any) {
    return bindActionCreators(
        {
            refreshList,
        },
        dispatch
    );
}

export default connect(null, mapDispatchToProps)(NewAnnouncementModal);